export interface CalculatorInputs {
  followers: number;
  reachRate: number; // fraction, e.g., 0.15
  engagementRate: number; // fraction of reach
  postsPerWeek: number;
  conversionRate: number; // fraction of engagements
  avgOrderValue: number; // USD
  monthlyAdSpend: number; // USD
}

export function calculateMetrics(inputs: CalculatorInputs) {
  const { followers, reachRate, engagementRate, postsPerWeek, conversionRate, avgOrderValue, monthlyAdSpend } = inputs;

  const weeklyReachPerPost = Math.max(0, Math.round(followers * reachRate));
  const weeklyImpressions = weeklyReachPerPost * postsPerWeek;
  const weeklyEngagements = Math.max(0, Math.round(weeklyImpressions * engagementRate));
  const monthlyEngagements = weeklyEngagements * 4;
  const monthlyConversions = Math.max(0, monthlyEngagements * conversionRate);
  const monthlyRevenue = monthlyConversions * avgOrderValue;
  const roi = monthlyAdSpend > 0 ? (monthlyRevenue - monthlyAdSpend) / monthlyAdSpend : Infinity;
  const roiPercent = Number.isFinite(roi) ? roi * 100 : 0;

  return {
    weeklyReach: weeklyReachPerPost,
    weeklyImpressions,
    weeklyEngagements,
    monthlyEngagements,
    monthlyConversions,
    monthlyRevenue,
    roi,
    roiPercent,
  };
}

// Project revenue timeline for next `months` months based on inputs.
// This uses a simplistic growth model: revenue per month = baseMonthlyRevenue * growthFactor^month
export function projectRevenueTimeline(inputs: CalculatorInputs, months = 12) {
  const base = calculateMetrics(inputs).monthlyRevenue;
  // Growth factor derived heuristically from engagement and posting frequency
  const growthBase = 1 + Math.max(0, (inputs.engagementRate - 0.02) * 2) + Math.max(0, (inputs.postsPerWeek - 3) * 0.03);
  const timeline: number[] = [];
  for (let m = 0; m < months; m++) {
    const value = base * Math.pow(growthBase, m) + (inputs.monthlyAdSpend ? inputs.monthlyAdSpend * 0.1 * m : 0);
    timeline.push(value);
  }
  return timeline;
}
